import { Navigate, Outlet } from 'react-router-dom';
import { useProfile } from '../hooks/useProfile';

export interface CountryRestrictedRouteProps {
  /** Absolute path to redirect to when the country is not authorized (e.g. `/${locale}/${espacePriveSlug}`). */
  redirectTo: string;
}

/**
 * Route guard: redirects to `redirectTo` when the profile's country is not authorized for the agenda.
 * Uses an absolute path rather than a relative `Navigate to="..">` because this component is meant to be
 * nested as a pathless layout route — React Router excludes pathless routes when resolving relative
 * navigation, so `".."` would skip past the intended parent route.
 */
export function CountryRestrictedRoute({ redirectTo }: Readonly<CountryRestrictedRouteProps>) {
  const { profile, isLoggedIn } = useProfile();

  if (isLoggedIn === undefined) return null;

  if (!profile?.isAgendaAuthorized) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
